import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from './useAuth';

/**
 * ADR-018 — leitura de 1 launch_deal por id.
 *
 * Ajustes Gemini aplicados (auth guard + filtro explícito por business_unit_id).
 */
export function useLaunchDeal(id) {
  const { user, loading: authLoading } = useAuth();
  const [deal, setDeal] = useState(null);
  const [launchesUnitId, setLaunchesUnitId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('business_units')
      .select('id')
      .eq('code', 'launches')
      .single()
      .then(({ data }) => {
        if (!cancelled && data?.id) setLaunchesUnitId(data.id);
      });
    return () => { cancelled = true; };
  }, []);

  const fetchDeal = useCallback(async () => {
    if (!id) {
      setDeal(null);
      setLoading(false);
      return;
    }
    if (authLoading || !launchesUnitId) {
      setLoading(true);
      return;
    }
    if (!user?.id) {
      setDeal(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { data, error: err } = await supabase
        .from('launch_deals')
        .select(
          'id, title, description, stage, status, valor_estimado, expected_close_date, next_step, next_step_due_date, owner, source, created_at, updated_at, orulo_building_id, empresa:empresas(id, empresa, company_name, cnpj)'
        )
        .eq('id', id)
        .eq('business_unit_id', launchesUnitId)
        .maybeSingle();
      if (err) throw err;
      setDeal(data || null);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [id, user?.id, authLoading, launchesUnitId]);

  useEffect(() => { fetchDeal(); }, [fetchDeal]);

  return { deal, loading: loading || authLoading || !launchesUnitId, error, refetch: fetchDeal };
}
